import React, { Component } from "react"
import I18n from "./i18n.js"
import ReactDOM from "react-dom"
import Select from 'react-select';

import 'react-select/dist/react-select.css';

class FacetSelect2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    }
  }

  getValue() {
    return this.state.value
  }

  componentDidUpdate(props) {
    if (this.props.value != props.value) {
      this.setState({ value: this.props.value })
    }
  }

  handleChange(value) {
    if (value) {
      value = this.props.multi ? value.map(v => v.value) : value.value;
    }
    this.setState({ value: value }, () => this.props.onChange())
  }

  render() {
    return <Select
      clearable={false}
      placeholder={'foo'}
      searchable={false}
      {...this.props}
      onChange={(val) => this.handleChange(val)}
    />;
  }
}
export default FacetSelect2;
